// DEPENDENCIES ---------------------------------------------------------------- //

import React from 'react';
import dayjs from 'dayjs';

import { TimelineProvider } from '@components/Timeline/Timeline/TimelineProvider';
import TimelineContent from '@components/Timeline/Timeline/TimelineContent';

// TYPES ---------------------------------------------------------------- //

interface TimelineProps {
  componentAreaRow?: React.ComponentType<any> | null;
  componentAreaRowProps?: Record<string, any>;
  componentIndexRow?: React.ComponentType<any> | null;
  componentIndexRowProps?: Record<string, any>;
  data?: any[];
  date?: string;
  header?: React.ReactNode;
  headerSize?: number;
  intervalCallback?: () => void;
  markers?: Array<{
    time: string;
    label: string;
    color?: string;
  }>;
  markerUpdateMs?: number;
  onTimelineReady?: (scrollFn: (scrollPosition: number) => void) => void;
  rowSize?: number;
  scrollKey?: string;
  showMarkers?: boolean;
  sidebarSize?: number;
  timezoneOverride?: string;
  zIndex?: number;
  zoom?: number;
}

// COMPONENT ---------------------------------------------------------------- //

const Timeline = ({
  componentAreaRow = null,
  componentAreaRowProps = {},
  componentIndexRow = null,
  componentIndexRowProps = {},
  data = [],
  date = dayjs().format(`YYYY-MM-DD`),
  header = undefined,
  headerSize = 48,
  intervalCallback = undefined,
  markers = [],
  markerUpdateMs = 15000,
  onTimelineReady = undefined,
  rowSize = 80,
  scrollKey = `timeline-scroll-sec`,
  showMarkers = true,
  sidebarSize = 256,
  timezoneOverride = dayjs.tz.guess(),
  zIndex = 0,
  zoom = 4,
}: TimelineProps) => {
  return (
    <TimelineProvider
      componentAreaRow={componentAreaRow}
      componentAreaRowProps={componentAreaRowProps}
      componentIndexRow={componentIndexRow}
      componentIndexRowProps={componentIndexRowProps}
      data={data}
      date={date}
      header={header}
      headerSize={headerSize}
      intervalCallback={intervalCallback}
      markers={markers}
      markerUpdateMs={markerUpdateMs}
      onTimelineReady={onTimelineReady}
      rowSize={rowSize}
      scrollKey={scrollKey}
      showMarkers={showMarkers}
      sidebarSize={sidebarSize}
      timezoneOverride={timezoneOverride}
      zIndex={zIndex}
      zoom={zoom}
    >
      <TimelineContent />
    </TimelineProvider>
  );
};

// -------------------------------- EXPORT -------------------------------- //

export default Timeline;
